import React, { useCallback, useEffect, useState } from 'react';
import { AlertsList } from '../../components/Alerts';
import {
	BREADCRUMB,
	HELPBUTTON,
	PAGETITLE,
	PAYPALBANNER,
	PRODUCTTILES,
	PROMOMSG
} from '../../constants/rootElements';
import { gaPageLoad } from "../../util/googleAnalytics";
import { Breadcrumb } from '../breadcrumb';
import { HelpButton } from '../help';
import { TitleBar } from '../productBrowseTitle';
import { AffiliationStoleProductTile } from './affiliationStoleProductTile';
import { useFeeAlertInjectionScript } from "../../hooks";
import { AfterPayBanner } from '../../components';

export const AffiliationStolePage = React.memo(({ appData }) => {
	const [pbData, setPbData] = useState({});
	const [catalogData, setCatalogData] = useState({});
	const [breadcrumbData, setBreadcrupmData] = useState([]);
	const [promoMessages, setPromoMessages] = useState([]);
	const [feeAlertRequestData, setFeeAlertRequestData] = useState(null);
    const [currencyCode, setCurrencyCode] = useState(null);
	useFeeAlertInjectionScript(feeAlertRequestData)

	const AffiliationStoleBreadcrumb = Boolean(
		appData?.pagecontentData?.find((data) => data?.contentType === 'Navigation')
	);
	const AffiliationStoleTitleBar = appData?.pagecontentData?.find(
		(data) => data?.contentType === 'ProductBrowseTitle'
	);
	const ProductBrowseProducts = appData?.pagecontentData?.find(
		(data) => data?.contentType === 'ProductBrowseProducts'
	);
	const PaypalBannerData = appData?.pagecontentData?.find(
		(data) => data?.contentType === 'PaypalId'
	);
	const AffiliationStoleFilterTile = appData?.pagecontentData?.find(
		(data) => data?.contentType === 'ProductBrowseFiltersBar'
	);
	const ProductBrowsePromoMsg = Boolean(
		appData?.pagecontentData?.find(
			(data) => data.contentType === 'ProductBrowsePromoMsg'
		)
	);

	const getBreadcrumb = useCallback(() => {
		BREADCRUMB.render(<Breadcrumb pbData={breadcrumbData} />);
	}, [breadcrumbData]);

	const getHelpButton = useCallback(() => {
        HELPBUTTON.render(<HelpButton />);
  },[]);

	const getTitleBar = useCallback(() => {
		PAGETITLE.render(
			<TitleBar
				pageContent={AffiliationStoleTitleBar}
				affiliationData={appData?.affiliationData}
			/>
		);
	}, []);

	const getPromoMsg = useCallback(() => {		
		PROMOMSG.render(<AlertsList messages={promoMessages} />);
	}, [promoMessages]);

	const productTiles = useCallback(() => {
		PRODUCTTILES.render(
			<AffiliationStoleProductTile
				pbData={pbData}
				pageContent={ProductBrowseProducts}
				filterData={appData?.filterData}
				serviceData={catalogData}
				fieldToCompare={AffiliationStoleFilterTile?.filedtocompare}
			/>
		);
		// eslint-disable-next-line
	}, [catalogData]);

	const paypalBanner = useCallback(() => {
		PAYPALBANNER.render(<AfterPayBanner currencyCode={currencyCode} />);
		},[PaypalBannerData, currencyCode])

	useEffect(() => {
		Object.keys(appData?.productBrowseData).map((key) => {
			if (key !== 'metaData') {
				const productGroups = appData?.productBrowseData[key]?.productGroups;
				productGroups && Object.keys(productGroups).map(
						(catObj) => {
							setFeeAlertRequestData({
								containerSelector: '#promoMsg',
								customerId: appData.productBrowseData.metaData.customerNumber,
								catalogOsr: appData.productBrowseData[key].catalogOsr,
							})
							const groupData = productGroups[catObj];
							setPbData(groupData);
							const _currencyCode = groupData?.products?.[0]?.currencyCode;
							_currencyCode && setCurrencyCode(_currencyCode);
							setCatalogData(appData?.productBrowseData[key]);
							setPromoMessages(appData.productBrowseData[key].promoMessages);
							setBreadcrupmData(groupData);
							return true;
						}
					);
			}
			return true;
		});
	}, [appData?.productBrowseData]);

	useEffect(()=>{
		if(appData.productBrowseData && Object.keys(appData.productBrowseData).length>0){
			gaPageLoad();
		}
	},[])
	return (
		<>
			{AffiliationStoleTitleBar &&
				Object.keys(AffiliationStoleTitleBar)?.length > 0 &&
				getTitleBar()
			}
			{ProductBrowsePromoMsg && promoMessages?.length > 0 && getPromoMsg()}
			{AffiliationStoleBreadcrumb && getBreadcrumb()}
			{ProductBrowseProducts &&
				Object.keys(ProductBrowseProducts)?.length > 0 &&
				productTiles()
			}
			{
        getHelpButton()
      }
			{PaypalBannerData &&
				Object.keys(PaypalBannerData)?.length > 0 &&
				paypalBanner()
			}
		</>
	);
});
